import { REVIEW_STATUS_CODE } from "../../constants/AppConstants";

export const krYESTERDAY = "어제";
export const krIN_1_WEEKS = "최근 7일";
export const krIN_1_MONTH = "최근 1개월";
export const krIN_3_MONTHS = "최근 3개월";
export const krALL = "전체";

export const krUNANSWERED = "미답변";
export const krPENDING = "등록 대기";
export const krSUCCESS = "등록 완료";
export const krFAILED = "등록 실패";
export const krEXCLUDED = "등록 제외";
export const krEXPIRED = "등록 불가";

export const kYESTERDAY = "YESTERDAY";
export const kIN_1_WEEKS = "IN_1_WEEKS";
export const kIN_1_MONTH = "IN_1_MONTH";
export const kIN_3_MONTHS = "IN_3_MONTHS";

export const kALL = REVIEW_STATUS_CODE.ALL.code;
export const kUNANSWERED = REVIEW_STATUS_CODE.UNANSWERED.code;
export const kPENDING = REVIEW_STATUS_CODE.PENDING.code;
export const kSUCCESS = REVIEW_STATUS_CODE.SUCCESS.code;
export const kFAILED = REVIEW_STATUS_CODE.FAILED.code
export const kEXCLUDED = REVIEW_STATUS_CODE.EXCLUDED.code;
export const kEXPIRED = REVIEW_STATUS_CODE.EXPIRED.code;

export const timeKeys = [kYESTERDAY, kIN_1_WEEKS, kIN_1_MONTH, kIN_3_MONTHS];

export const reviewStatusKeys = [
  kALL,
  kUNANSWERED,
  kPENDING,
  kSUCCESS,
  kFAILED,
  kEXCLUDED,
  kEXPIRED,
];

export const timeTranslateKr = [
  krYESTERDAY,
  krIN_1_WEEKS,
  krIN_1_MONTH,
  krIN_3_MONTHS,
];

export const reviewStatusKr = [
  krALL,
  krUNANSWERED,
  krPENDING,
  krSUCCESS,
  krFAILED,
  krEXCLUDED,
  krEXPIRED,
];
const keys = [...reviewStatusKeys, ...timeKeys];
const krs = [...reviewStatusKr, ...timeTranslateKr];
export const key2Kr = (key) => {  
  const i = keys.indexOf(key);
  if (i < 0) {
    return "";
  }
  return krs[i];
};

export const kr2Key = (kr) => {
  const i = krs.indexOf(kr);
  if (i < 0) {
    return "";
  }
  return keys[i];
};



export const getAiSettingTimePostDay = (aiSettingTimePost) => {
  let aiSettingTimePostDay;
  if (aiSettingTimePost == "NO_USE") {
    aiSettingTimePostDay = 0;
  } else {
    try {
      aiSettingTimePostDay = +aiSettingTimePost.split("_")[0];
    } catch (e) {
      aiSettingTimePostDay = 0;
    }
  }
}